import { ConfigModuleCategory } from 'library/ts/model/enums/config/ConfigModuleCategory';
import { IAdExpParams } from 'tag/ts/tag/interfaces/config/adexp/IAdExpParams';

/**
 * @copyright © Paramount Streaming
 * @description Ad Experience plugin config for Avia/Blackbird (grace period and UI container).
 */
export const TagConfigAdExp = {
	category: ConfigModuleCategory.PLUGIN,
	enabled: true,
	params: {
		gracePeriodDuration: {
			startGracePeriodSeconds: 30,
			midGracePeriodSeconds: 15
		},
		uiContainer: '#playerContainer'
	} as IAdExpParams
};